module.exports = __webpack_public_path__ + "img/clientes.56e6b321.jpeg";